import { divide } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'
import RepostContent from '../../Services/Mutations/RepostContent'
class RepostContentAction extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			reportModalVisible: false,
			contentMainCategory: 'news',
			currentUserDetails: {},
		}
	}
	handleModal = (visible) => {
		this.setState({ reportModalVisible: visible })
	}

	closeRepostModal = () => {
		this.setState({
			contentMainCategory: 'news',
			reportModalVisible: false,
		})
	}
	//handle add or remove radio buttons
	handleMainCategory = (category) => {
		this.setState({ contentMainCategory: category })
	}

	repostContent = async () => {
		const input = {
			contentID: await uuidv4(),
			oldContentID: this.props.item.PK,
			contentMainCategory: this.state.contentMainCategory,
			appInfoFrontEnd: {
				UUID: Auth.user.username,
				appVersionNumber: 65,
			},
		}
		this.setState({
			contentMainCategory: 'news',
			reportModalVisible: false,
		})
		try {
			console.log(input, 'input')
			const response = await RepostContent(input)
			console.log(response, 'responseeeeeeeeeeee=============')

			if (response.statusCode == 'A311') {
				this.props.displayToast('success', 'Repost Content Successful')
			} else {
				this.props.displayToast('error', 'Failed to repost content')
			}
		} catch (error) {
			return error
		}
	}
	componentDidMount = async () => {
		this.setState({
			contentMainCategory: this.props.item.contentMainCategory
				? this.props.item.contentMainCategory
				: 'news',
		})
	}
	render() {
		const { reportModalVisible, contentMainCategory } = this.state
		return (
			< >
				{this.props.rank ? (
					<div
						class='col-md-3 faIconClass '
						onClick={() => {
							this.handleModal(true)
						}}
					>
						<label>Repost Content</label>
					</div>
				) : (
					<div
						data-toggle='tooltip'
						title={`Repost Content`}
						style={{ fontSize: '12px' }}
						class='col-md-3 faIconClass '
						onClick={() => {
							this.handleModal(true)
						}}
					>
						<i class='fas fa-retweet fa-lg' />
					</div>
				)}

				<Modal show={reportModalVisible} onHide={() => this.closeRepostModal()}>
					<Modal.Body>
						<div className='row'>
							<div class='row'>
								<label for='text'>Choose Content Main Category</label>
							</div>
							<div class='row'>
								<div>
									<input
										value={'news'}
										type='radio'
										checked={contentMainCategory == 'news'}
										onChange={() => {
											this.handleMainCategory('news')
										}}
									></input>
									<text for='news'>News</text>
								</div>
								<div>
									<input
										value={'infoRegular'}
										type='radio'
										checked={contentMainCategory == 'infoRegular'}
										onChange={() => {
											this.handleMainCategory('infoRegular')
										}}
									></input>
									<text for='infoRegular'>Info Regular</text>
								</div>
								<div>
									<input
										value={'infoImportant'}
										type='radio'
										checked={contentMainCategory == 'infoImportant'}
										onChange={() => {
											this.handleMainCategory('infoImportant')
										}}
									></input>
									<text for='infoImportant'>Info Important</text>
								</div>
								<div>
									<input
										value={'infoHighlight'}
										type='radio'
										checked={contentMainCategory == 'infoHighlight'}
										onChange={() => {
											this.handleMainCategory('infoHighlight')
										}}
									></input>
									<text for='infoHighlight'>Info Highlight</text>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closeRepostModal()}>Cancel</Button>

						<Button onClick={() => this.repostContent()}>Repost</Button>
					</Modal.Footer>
				</Modal>
			</>
		)
	}
}

export default RepostContentAction
